import { Text } from 'components/Base/Typography';
import { Flex } from 'antd';

const registrationFields = ['First Name', 'Last Name', 'Phone', 'Email'];

const RegistrationFields = () => {
  return (
    <Flex vertical gap={4}>
      <Text fontSize={14} color="#656565">
        This fields that are required by a user in the registration form
      </Text>
      <Flex vertical gap={4} style={{ paddingLeft: 24 }}>
        {registrationFields.map(field => (
          <Text key={field} style={{ position: 'relative' }}>
            <span style={{ position: 'absolute', left: -16 }}>•</span>
            {field}
          </Text>
        ))}
      </Flex>
    </Flex>
  );
};

export default RegistrationFields;
